import {Middleware} from '@reduxjs/toolkit'

import {Sentry} from '@web/helpers/log'

import {RootState} from '../../interfaces'

const sentryTransaction: Middleware<object, RootState> =
    ({getState}) =>
    (next) =>
    (action) => {
        const nextState = getState()

        Sentry.setTags({
            seqId: nextState.common?.seqID,
        })

        next(action)
    }

export default sentryTransaction
